import React from "react";
import classNames from "classnames";
// import PropTypes from "prop-types";
import styles from "./slide-track-container.module.scss";
import noOp from "lib/no-op";
import Ubung from "../ubung/ubung";

const SlideTrackContainer = ({
  activeTrackId = 0,
  ubung,
  nrTracks = 0,
  _onClickPlayerNav = noOp(),
  metadata = [],
}) => {
  const { level } = ubung;

  return (
    <div className={classNames(styles.root)}>
      <div className={styles.mainContainer}>
        <Ubung
          ubung={ubung}
        />
      </div>
    </div>
  );
};

SlideTrackContainer.defaultProps = {};

SlideTrackContainer.propTypes = {};

export default SlideTrackContainer;
